


















































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {$, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import _ from 'lodash'
import ResponsavelUsuario from '@/model/resource/ResponsavelUsuario'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers/'
import {ItrackCollection} from '@/helpers'

const metaInfo = () => ({
  title: $.t('view.persist.respUserPersistView.title'),
})

enum TipoResponsavelUsuario {
  ADMIN = 1,
  MASTER,
  VISUALIZADOR,
  SAC,
  RASTREAMENTO,
}

@Component({
  metaInfo,
})
export default class RespUserPersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID

  AppConfig = AppConfig

  TipoResponsavelUsuario = TipoResponsavelUsuario

  listToPersist: ResponsavelUsuario[] = []

  allFilial = ItrackCollection.allFilialFilter

  persistThrottled = _.throttle(() => this.persist(), 7000)

  created() {
    this.$set(this.listToPersist, 0, new ResponsavelUsuario())
  }

  async mounted() {
    if (this.id) await this.listToPersist[0].getResponsavelUsuario(this.id)
    await this.allFilial.query()
    this.allFilial.items.forEach((item: Responsavel) => {
      let nomeFantasia = ''
      if (item.nomeFantasia) {
        nomeFantasia = `${$.filter.truncate(item.nomeFantasia || '', 20)} - `
      }

      item.$tag = `${nomeFantasia}${Helper.cnpj(item.cnpj)}`
    })
    await this.$nextTick()
    $.await.done('getRespUser')
  }

  addItem() {
    this.listToPersist.push(new ResponsavelUsuario())
  }

  removeItem(item: ResponsavelUsuario) {
    const index = this.listToPersist.indexOf(item)
    if (index > -1) {
      this.listToPersist.splice(index, 1)
      this.$forceUpdate()
    }
  }

  async persist() {
    await ResponsavelUsuario.persistLote(this.listToPersist)
    successAndPush('system.success.persist', '/manage/resp-user/list')
  }

}
